import React, { useState, useEffect } from "react";
import { Layout, Menu, Breadcrumb } from "antd";

import { Link, useLocation } from "react-router-dom";

import { routes } from "../routes";
import GainIcon from "../components/gainicon";
import NavHeader from "./Layout/NavHeader";
import Login from "../pages/Login";

const { Header, Content, Sider } = Layout;
const { SubMenu } = Menu;

export default function Layouts({ children }) {
  let location = useLocation();

  const [Bread, setBread] = useState(false);
  const [BreadChild, setBreadChild] = useState(false);

  useEffect(() => {
    const res = routes.filter(
      (item) => item.path === "/" + location.pathname.split("/")[1]
    )[0];

    if (res) {
      setBread(res);
      if (res.children) {
        const child = res.children.filter(
          (item) => item.path === location.pathname
        )[0];
        setBreadChild(child);
      } else {
        setBreadChild(false);
      }
    }
  }, [location.pathname]);

  return (
    <Layout className="min-h-screen">
      <Sider className="min-w-max max-w-max bg-gain fixed h-screen z-20">
        <div className="flex flex-col px-7 py-5 font-bold">
          <span className="text-white text-3xl">LOGO</span>
          <span className="text-purple-500 text-2xl">Asia</span>
        </div>
        <span className="px-6 text-gray-300 text-xs">Main Menu</span>
        <Menu
          className="bg-gain text-white border-none"
          mode="inline"
          defaultSelectedKeys={["2"]}
        >
          {routes.map((item) =>
            item.children ? (
              <SubMenu
                key={item.key}
                icon={<GainIcon name={item.icon} />}
                title={<div className="px-3">{item.name}</div>}
              >
                {item.children.map((child) => (
                  <Menu.Item
                    key={`sub-${child.key}`}
                    className="bg-gain text-white border-none"
                    icon={<span className="-mt-1">&#9864; </span>}
                  >
                    <Link to={child.path} className="text-white">
                      <p className="leading-4 whitespace-normal w-32 pt-3">
                        {child.name}
                      </p>
                    </Link>
                  </Menu.Item>
                ))}
              </SubMenu>
            ) : (
              <Menu.Item key={item.key} icon={<GainIcon name={item.icon} />}>
                <Link to={item.path} className="text-white px-3">
                  {item.name}
                </Link>
              </Menu.Item>
            )
          )}
        </Menu>
      </Sider>
      <Layout className="ml-64">
        <Header className="bg-white sticky top-0 w-full z-50">
          <NavHeader />
        </Header>
        {/* <Breadcrumb className="px-16 py-10 fixed top-14 w-full z-10" style={{backgroundColor: "#f0f2f5"}}> */}
        <Breadcrumb className="px-16 py-10 w-full">
          <Breadcrumb.Item>Home</Breadcrumb.Item>

          <Breadcrumb.Item>
            <Link to="/">{Bread.name}</Link>
          </Breadcrumb.Item>

          {BreadChild && (
            <Breadcrumb.Item>
              <Link to="">{BreadChild.name}</Link>
            </Breadcrumb.Item>
          )}
        </Breadcrumb>
        <Content className="min-h-screen px-16 pb-24">
          {/* <h1 className="text-3xl font-bold">{BreadChild ? BreadChild.name : Bread.name}</h1> */}
          {children}
        </Content>
      </Layout>
    </Layout>
  );
}
